// extracted by mini-css-extract-plugin
export default {"cls1":"WorkCard-cls1_g0_","cls2":"WorkCard-cls2_P2a WorkCard-cls1_g0_"};